import { render, staticRenderFns } from "./applySettlementInstitution.vue?vue&type=template&id=6f3e1668"
import script from "./applySettlementInstitution.vue?vue&type=script&lang=js"
export * from "./applySettlementInstitution.vue?vue&type=script&lang=js"
import style0 from "./applySettlementInstitution.vue?vue&type=style&index=0&id=6f3e1668&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports